import React, { Component } from 'react';
import AdvForm from '../../CommonComponents/AdvForm';
import Modal from '../../CommonComponents/AdvModal';
import ErrorBubble from '../../CommonComponents/ErrorBubble';

class EditPDFSectionModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      modal_open,
      on_cancel,
      on_save,
      title,
      reactFields,
      warnings,
      on_hide_warnings,
    } = this.props;
    return (
      <Modal
        isOpen={modal_open}
        onRequestClose={() => {
          on_hide_warnings();
          on_cancel();
        }}
        shouldCloseOnOverlayClick={false}
        className="popup insert-cover-page"
        overlayClassName="closerdiv"
      >
        <h2 className="title">
          {title}
          <i onClick={on_cancel} className="fa fa-times close" />
        </h2>
        <ErrorBubble
          show={warnings && warnings.length > 0}
          on_hide={on_hide_warnings}
          InfoMessage={warnings}
        />
        <AdvForm>
          <ul className="vertical-layout">{reactFields}</ul>
        </AdvForm>

        <div className="actions">
          <button onClick={on_save} className="green rhs" id="btn-save">
            Save Changes
          </button>
          <button onClick={on_cancel} className="secondary dismiss lhs" id="btn-cancel">
            Cancel
          </button>
        </div>
      </Modal>
    );
  }
}

export default EditPDFSectionModal;
